/**
 * @desc getTestGenerateUrl
 */
const URL = "/rantion-walmart";
import http, { updateResponse } from "@/http";
export function request(options?: any) {
  return updateResponse(
    http(URL + `/test/getTestGenerateUrl`, {
      method: "GET",

      ...options,
    }),
  );
}
